module.exports = __webpack_public_path__ + "img/item_Story_18.658501f3.jpeg";